/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @interface ColorSetAPI
 * @hideconstructor
 * @classdesc Internal API class that is used to provide generated css styles for color styles.
 */
define([], () => {
	class ColorSetAPI {

		/**
		 * Generate color styles template		 
		 * @param {String} paletteId - the ID to use for the base color palette
		 * @returns {Promise} promise that resolves into a string describing the css style
		 * @example 
		   //hard coded style
		   ColorSetAPI.getColorStyles(paletteId) { return ".fill-color1 { background-color: #1234 !important; }}"
		 */
		getColorStyles() {}
	}

	return ColorSetAPI;
});
